// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { Tab } from 'components/molecules/Tab';
import { useHistory } from 'react-router';
import AdminTenantManagement from '../AdminTenantManagement';
import CustomizeListCategory from '../CustomizeListCategory';
import { CustomizeItemBreadcrumbs } from 'util/Types';
import styles from './EmissionSiteDetailManagement.module.scss';

type EmissionSiteDetailManagementProps = {
  onSetBreadcrumb: (breadcrumb: CustomizeItemBreadcrumbs) => void;
};

const EmissionSiteDetailManagement: React.FC<
  EmissionSiteDetailManagementProps
> = ({ onSetBreadcrumb: setBreadcrumb }) => {
  const history = useHistory();

  return (
    <Tab
      className={styles.tabAdminCustomize}
      tabItems={['テナント設定', '品目設定']}
      defaultTabIndex={history.location.hash == '#1' ? 1 : 0}
      renderContent={({ index }) => (
        <div>
          <h4 className={styles.titleCustomize}>
            {index === 1 ? '品目カテゴリ一覧画面' : 'テナント一覧'}
          </h4>
          {index === 0 && (
            <AdminTenantManagement
              onSetBreadcrumb={(operatorName, siteName) => {
                setBreadcrumb({ operatorName, siteName });
              }}
            />
          )}
          {index === 1 && (
            <CustomizeListCategory
              onSetBreadcrumb={(operatorName, siteName) => {
                setBreadcrumb({ operatorName, siteName });
              }}
            />
          )}
        </div>
      )}
    />
  );
};

export default EmissionSiteDetailManagement;
